import BadgeActionItem from '@/components/BadgeActionList/BadgeActionItem';
import type {BadgeAction} from '@/types/loyalty';

type BadgeActionListProps = {
    actions?: BadgeAction[];
};

const BadgeActionList = ({actions}: BadgeActionListProps) => {
    // The first not-completed action is "current" (clickable).
    // Subsequent not-completed actions are "locked" (shown with a lock icon, no
    // interaction).
    const hasActions = actions && actions.length > 0;
    if (!hasActions) return null;

    // Match by index, not id — backend can return duplicate ids, so only the
    // first not-completed action must be "current".
    const currentIndex = actions.findIndex((a) => !a.isCompleted);

    return (
        <ul className='m-0 flex w-full list-none flex-col gap-1 p-0 px-4'>
            {actions.map((action, index) => (
                // Backend can return duplicate action ids — combine with index for a stable unique key.
                <BadgeActionItem key={`${action.id}-${index}`} action={action} isCurrent={index === currentIndex} />
            ))}
        </ul>
    );
};

export default BadgeActionList;
